import React from 'react';
import './Welcome.scss';
import GreetingUser from '../GreetingUser';

const Welcome = () => {
    return (
        <div className="welcome-component">
            <GreetingUser />
        </div>
    );
};

export default Welcome;
